import {useAgendaCategoryCustom} from '@/features/agenda/hooks/useAgendaCategoryCustom'
import {useAgendaCategoryPatientAgeRange} from '@/features/agenda/hooks/useAgendaCategoryPatientAgeRange'
import {useAgendaCategoryTeam} from '@/features/agenda/hooks/useAgendaCategoryTeam'
import {useMemo} from 'react'

export const useRetrieveResources = () => {
    const {team} = useAgendaCategoryTeam()
    const {users: specializationUsers} = useAgendaCategoryPatientAgeRange()
    const {subjects: customSubjects} = useAgendaCategoryCustom<'users'>()

    const subjects =
        customSubjects.length > 0
            ? customSubjects
            : team.length > 0
              ? team
              : specializationUsers.length > 0
                ? specializationUsers
                : []

    const resources = useMemo(() => {
        return subjects?.map(subject => ({
            resourceId: subject.id,
            resourceTitle: subject.fullName,
            specializationName: subject.specializationName
        }))
    }, [subjects])

    return resources?.length == 1 ? undefined : resources
}
